export default "__VITE_ASSET__zHRi3v8x__"